<template>
	<div class="airport-test-page">
		<div class="page-header">
			<h1>BizApi.Destination.AirportForAllGet 接口测试</h1>
			<p class="description">测试获取所有机场列表接口</p>
		</div>

		<div class="test-section">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>请求参数</span>
				</div>
				<el-form :model="requestParams" label-width="120px">
					<el-form-item label="关键字">
						<el-input 
							v-model="requestParams.keyword" 
							placeholder="输入机场名称、城市名称或机场代码"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item label="国家代码">
						<el-input 
							v-model="requestParams.countryCode" 
							placeholder="例如：CN (中国), US (美国)"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button 
							type="primary" 
							@click="testGetAirportList"
							:loading="loading"
							icon="el-icon-search"
						>
							调用接口
						</el-button>
						<el-button @click="clearResult">清空结果</el-button>
					</el-form-item>
				</el-form>
			</el-card>
		</div>

		<div class="result-section" v-if="apiResponse">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>接口响应</span>
					<el-tag 
						:type="apiResponse.Success ? 'success' : 'danger'" 
						style="float: right;"
					>
						{{ apiResponse.Success ? '成功' : '失败' }}
					</el-tag>
				</div>

				<!-- 成功响应 -->
				<div v-if="apiResponse.Success">
					<el-alert
						title="接口调用成功"
						type="success"
						:closable="false"
						style="margin-bottom: 20px;"
					>
					</el-alert>

					<!-- 机场列表 -->
					<div v-if="airportList && airportList.length > 0">
						<h3>机场列表 (共 {{ airportList.length }} 个)</h3>
						<el-table 
							:data="airportList" 
							border 
							style="width: 100%; margin-top: 10px;"
							max-height="500"
						>
							<el-table-column 
								type="index" 
								label="序号" 
								width="60"
								align="center"
							>
							</el-table-column>
							<el-table-column 
								prop="AirportCode" 
								label="机场代码" 
								width="120"
								align="center"
							>
							</el-table-column>
							<el-table-column 
								prop="AirportName" 
								label="机场名称" 
								min-width="200"
							>
							</el-table-column>
							<el-table-column 
								prop="CityName" 
								label="城市" 
								width="150"
							>
							</el-table-column>
							<el-table-column 
								prop="CountryName" 
								label="国家" 
								width="120"
							>
							</el-table-column>
							<el-table-column 
								prop="CountryCode" 
								label="国家代码" 
								width="100"
								align="center"
							>
							</el-table-column>
						</el-table>
					</div>

					<!-- 没有数据 -->
					<el-empty 
						v-else 
						description="暂无机场数据"
						:image-size="100"
					></el-empty>
				</div>

				<!-- 失败响应 -->
				<div v-else>
					<el-alert
						:title="apiResponse.Message || '接口调用失败'"
						type="error"
						:closable="false"
						style="margin-bottom: 20px;"
					>
					</el-alert>
				</div>

				<!-- 原始响应数据 -->
				<el-collapse style="margin-top: 20px;">
					<el-collapse-item title="查看原始响应数据" name="1">
						<pre class="json-data">{{ JSON.stringify(apiResponse, null, 2) }}</pre>
					</el-collapse-item>
				</el-collapse>
			</el-card>
		</div>

		<!-- 接口说明 -->
		<div class="info-section">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>接口说明</span>
				</div>
				<div class="info-content">
					<p><strong>接口名称：</strong>BizApi.Destination.AirportForAllGet</p>
					<p><strong>接口功能：</strong>获取所有机场列表</p>
					<p><strong>请求方式：</strong>POST</p>
					<p><strong>接口位置：</strong>src/apiv2/biz5xApi.js - GetAirportForAll()</p>
					<p><strong>文档地址：</strong>
						<a href="https://bizapi.yiqifei.cn/Doc/" target="_blank">
							https://bizapi.yiqifei.cn/Doc/
						</a>
					</p>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import bizApi from '@/apiv2/biz5xApi'

export default {
	name: 'AirportTest',
	data() {
		return {
			loading: false,
			requestParams: {
				keyword: '',
				countryCode: ''
			},
			apiResponse: null,
			airportList: []
		}
	},
	created() {
		console.log('机场接口测试页面已加载')
	},
	methods: {
		// 测试获取机场列表接口
		testGetAirportList() {
			const that = this
			that.loading = true
			
			// 构建请求参数
			const params = {}
			if (that.requestParams.keyword) {
				params.keyword = that.requestParams.keyword
			}
			if (that.requestParams.countryCode) {
				params.countryCode = that.requestParams.countryCode
			}
			
			console.log('请求参数：', params)
			
			// 调用接口
			bizApi.GetAirportForAll(params, (result) => {
				that.loading = false
				that.apiResponse = result
				
				console.log('接口返回结果：', result)
				
				if (result.Success) {
					// 根据实际返回的数据结构来处理
					// 这里假设返回的数据在 result.Data 中
					if (result.Data) {
						// 如果 Data 是数组
						if (Array.isArray(result.Data)) {
							that.airportList = result.Data
						} 
						// 如果 Data 是对象，包含 List 或类似的属性
						else if (result.Data.List) {
							that.airportList = result.Data.List
						}
						// 如果 Data 是对象，包含 Airports 或类似的属性
						else if (result.Data.Airports) {
							that.airportList = result.Data.Airports
						}
						else {
							that.airportList = []
						}
					} else {
						that.airportList = []
					}
					
					that.$message.success('接口调用成功！')
				} else {
					that.airportList = []
					that.$message.error(result.Message || '接口调用失败')
				}
			})
		},
		
		// 清空结果
		clearResult() {
			this.apiResponse = null
			this.airportList = []
			this.requestParams = {
				keyword: '',
				countryCode: ''
			}
		}
	}
}
</script>

<style scoped>
.airport-test-page {
	padding: 20px;
	max-width: 1400px;
	margin: 0 auto;
}

.page-header {
	text-align: center;
	margin-bottom: 30px;
	padding: 20px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	border-radius: 8px;
}

.page-header h1 {
	margin: 0 0 10px 0;
	font-size: 28px;
}

.page-header .description {
	margin: 0;
	font-size: 14px;
	opacity: 0.9;
}

.test-section,
.result-section,
.info-section {
	margin-bottom: 20px;
}

.box-card {
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}

.clearfix:after {
	clear: both;
}

.json-data {
	background-color: #f5f7fa;
	padding: 15px;
	border-radius: 4px;
	font-size: 12px;
	line-height: 1.5;
	overflow-x: auto;
	max-height: 400px;
}

.info-content p {
	margin: 10px 0;
	line-height: 1.8;
}

.info-content a {
	color: #409EFF;
	text-decoration: none;
}

.info-content a:hover {
	text-decoration: underline;
}

/* 响应式 */
@media (max-width: 768px) {
	.airport-test-page {
		padding: 10px;
	}
	
	.page-header h1 {
		font-size: 20px;
	}
}
</style>

